import { ColumnSelectionFilter } from './ColumnSelectionFilter';
import {
  useOperatorTableStore,
  initialOperatorColumns,
} from 'views/pages/Admin/Operator/Filters/filters.store';
import { Button } from '@mui/material';
import { ColumnPreferencesConfig } from '@common/types';

type OperatorColumnKey =
  'name' | 'partner_name' | 'city' | 'county' | 'building_count';

const OPERATOR_TABLE_COLUMN_LABELS: Record<OperatorColumnKey, string> = {
  name: 'Name',
  partner_name: 'Partner',
  city: 'City / State',
  county: 'County',
  building_count: 'Buildings',
};

const ALL_FIELDS = initialOperatorColumns.map(
  c => c.field,
) as OperatorColumnKey[];

export const OperatorTableColumnSelectionFilter = ({
  hideText,
}: {
  hideText?: boolean;
}) => {
  const hiddenColumns = useOperatorTableStore(s => s.hiddenColumns);
  const setHiddenColumns = useOperatorTableStore(s => s.setHiddenColumns);

  const columns: Partial<Record<OperatorColumnKey, ColumnPreferencesConfig>> =
    Object.fromEntries(
      ALL_FIELDS.map((field, index) => [
        field,
        {
          column_display: hiddenColumns.includes(field) ? 'hidden' : 'display',
          column_order: index,
          column_size: 160,
        } satisfies ColumnPreferencesConfig,
      ]),
    );

  const handleSelectionChange = (
    selection: Partial<Record<OperatorColumnKey, ColumnPreferencesConfig>>,
  ) => {
    setHiddenColumns(
      ALL_FIELDS.filter(field => selection[field]?.column_display === 'hidden'),
    );
  };

  return (
    <ColumnSelectionFilter
      name='operator_table_columns'
      label='Columns'
      hideText={hideText}
      columns={columns}
      columnLabels={OPERATOR_TABLE_COLUMN_LABELS}
      onChange={handleSelectionChange}
      footerAction={
        <Button color='primary' onClick={() => setHiddenColumns([])}>
          RESET
        </Button>
      }
    />
  );
};
